/**
 * Etiquetas de estado de la orden de venta para mostrar en la UI.
 * Los valores enviados al backend siguen siendo CONFIRMADO, ENVIADO, etc.
 */

const ESTADO_PEDIDO_LABELS = {
  CONFIRMADO: "Confirmada",
  ENVIADO: "Enviada al cliente",
  RECIBIDO: "Recibida por el cliente",
  CANCELADO: "Cancelada",
};

const ESTADO_PAGO_LABELS = {
  PAGADO: "Pagada",
  PAGO_PARCIAL: "Parcialmente pagada",
  NO_PAGADO: "Impaga",
};

const ESTADO_PRESUPUESTO_LABELS = {
  CREADO: "Creado",
  PEDIDO_CREADO: "Orden de venta creada",
};

/**
 * @param {string} estado - CONFIRMADO | ENVIADO | RECIBIDO | CANCELADO
 * @returns {string}
 */
export function labelEstadoPedido(estado) {
  if (estado == null || estado === "") return "—";
  return ESTADO_PEDIDO_LABELS[estado] || estado;
}

/** Alias para órdenes de venta (misma lógica que labelEstadoPedido). */
export const labelEstadoOrdenVenta = labelEstadoPedido;

/**
 * @param {string} estadoPago - PAGADO | NO_PAGADO
 * @returns {string}
 */
export function labelEstadoPago(estadoPago) {
  if (estadoPago == null || estadoPago === "") return "—";
  return ESTADO_PAGO_LABELS[estadoPago] || estadoPago;
}

/**
 * @param {string} estado - CREADO | PEDIDO_CREADO
 * @returns {string}
 */
export function labelEstadoPresupuesto(estado) {
  if (estado == null || estado === "") return "Creado";
  return ESTADO_PRESUPUESTO_LABELS[estado] || estado;
}

/** Celeste (info) para Creado, verde (success) para Pedido creado. */
export function colorChipEstadoPresupuesto(estado) {
  if (estado === "PEDIDO_CREADO") return "success";
  return "info"; // CREADO, null → celeste
}
